"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TipLabelTypeEnum = exports.ConditionEnum = exports.StyleEnum = exports.IconEnum = exports.ColorEnum = void 0;
var ColorEnum;
(function (ColorEnum) {
    ColorEnum["Primary"] = "primary";
    ColorEnum["Secondary"] = "secondary";
    ColorEnum["HighEmphasis"] = "highEmphasis";
    ColorEnum["MediumEmphasis"] = "mediumEmphasis";
    ColorEnum["LowEmphasis"] = "lowEmphasis";
    ColorEnum["Background"] = "background";
    ColorEnum["Green"] = "green";
})(ColorEnum || (exports.ColorEnum = ColorEnum = {}));
var IconEnum;
(function (IconEnum) {
    IconEnum["Dollar"] = "dollar";
    IconEnum["Yen"] = "yen";
    IconEnum["Rial"] = "rial";
    IconEnum["Percent"] = "percent";
    IconEnum["Bill"] = "bill";
    IconEnum["ItemPercent"] = "itemPercent";
    IconEnum["ItemBill"] = "itemBill";
    IconEnum["Discount"] = "discount";
    IconEnum["LoyaltyDiscount"] = "loyaltyDiscount";
})(IconEnum || (exports.IconEnum = IconEnum = {}));
var StyleEnum;
(function (StyleEnum) {
    StyleEnum["TitleMedium"] = "titleMedium";
    StyleEnum["TitleSmall"] = "titleSmall";
    StyleEnum["BodyMedium"] = "bodyMedium";
    StyleEnum["BodySmall"] = "bodySmall";
    StyleEnum["BodyMediumStrike"] = "bodyMediumStrike";
    StyleEnum["BodySmallStrike"] = "bodySmallStrike";
})(StyleEnum || (exports.StyleEnum = StyleEnum = {}));
var ConditionEnum;
(function (ConditionEnum) {
    ConditionEnum["Default"] = "";
    ConditionEnum["GT"] = "gt";
    ConditionEnum["GTE"] = "gte";
    ConditionEnum["LT"] = "lt";
    ConditionEnum["LTE"] = "lte";
    ConditionEnum["NE"] = "ne";
    ConditionEnum["E"] = "e";
    ConditionEnum["GTD"] = "gtd";
})(ConditionEnum || (exports.ConditionEnum = ConditionEnum = {}));
var TipLabelTypeEnum;
(function (TipLabelTypeEnum) {
    TipLabelTypeEnum["Satisfaction"] = "satisfaction";
    TipLabelTypeEnum["Service"] = "service";
    TipLabelTypeEnum["Stars"] = "stars";
    TipLabelTypeEnum["Ticks"] = "ticks";
    TipLabelTypeEnum["Disabled"] = "disabled";
})(TipLabelTypeEnum || (exports.TipLabelTypeEnum = TipLabelTypeEnum = {}));
